var render = function render(){var _vm=this,_c=_vm._self._c;return _c('global-footer',{staticClass:"footer custom-render",scopedSlots:_vm._u([{key:"links",fn:function(){return undefined},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }